export default __webpack_public_path__ + "media/images/icons/close-fb13c4b2082e095c47d111ff338925f7.svg";